import React, { Component } from 'react'
import withStyles from '../../withStylesAdapter';
import withRouter from 'with-router'
import { connect } from 'react-redux'
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Link from '@mui/material/Link';
import API from '../../api/api.js'
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { Trans, withTranslation, useTranslation } from 'react-i18next';



class Admin extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      richtextEditorVersion: 'v2',
      richtextEditorOnParagraphFields: false,
      importV1ProductMetafieldsProgress: 0,
    };
  }

  onImportV1ProductMetafieldTranslations = () => {
  	const editLanguage = this.props.editLanguage;

    this.setState({
      importV1ProductMetafieldsProgress: 1,
    });

  	API.syncProducts(
  		editLanguage,
  		progress => {
  			console.log('sync products: ' + progress)
  		},
      response => {
        if(response.success == true) {
          this.syncProductMetafields(
            editLanguage,
            response.products.slice(0, 10),
            0,
            progress => {
              console.log('import translations: ' + progress);
              this.setState({
                importV1ProductMetafieldsProgress: progress,
              });
            },
            result => {
              console.log(result);
              this.setState({
                importV1ProductMetafieldsProgress: 100,
              });
            }
          )
        }
      }
    );
  };

  syncProductMetafields = (language, products, index, progress, result) => {
  	if(index >= products.length - 1) {
  		result('!');
  	} else {
	  	API.syncProductMetafields(
	  		products[index].id,
	  		language,
	  		progress => {},
	  		response => {
	  			if(response.success == true && response.metafields.length > 0) {
					API.importV1ProductMetafieldTranslations(
						language,
						products[index].id,
						response.metafields,
						progress => {},
						response => {
				  			progress(Math.ceil(index / (products.length - 1) * 100));
				  			this.syncProductMetafields(language, products, index + 1, progress, result);
						}
					);
	  			} else {
		  			progress(Math.ceil(index / (products.length - 1) * 100));
		  			this.syncProductMetafields(language, products, index + 1, progress, result);
	  			}
	  		}
  		)
  	}
  };


  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Typography variant="h4" gutterBottom component="h2">
          Support Admin
        </Typography>
        <Divider className="divider-white" />
        <Paper className={classes.root} elevation={1}>
          

          <FormControl component="fieldset" fullWidth>
            <FormLabel component="legend">Import V1 Product Metafield Translations</FormLabel>
            <Divider style={{margin: '8px 0'}} />
            <Typography>
              Imports existing langify v1 metafield translations into v2 <br />
              <Button 
                onClick={e => {this.onImportV1ProductMetafieldTranslations()}} 
                disabled={(this.state.importV1ProductMetafieldsProgress > 0)}
                variant="contained" 
                color="primary" 
                fullWidth={false}>
                {this.state.importV1ProductMetafieldsProgress < 100 ? 'Import' : 'Done'}
                {(this.state.importV1ProductMetafieldsProgress > 0 && this.state.importV1ProductMetafieldsProgress < 100) &&
                  <CircularProgress size={20} variant="determinate" />
                }
              </Button>
            </Typography>
          </FormControl>

        </Paper>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ shop }) => ({
  editLanguage: shop.shop.edit_language
})

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: 20,
    overflowX: 'auto',
    padding: 24,
  },
  subtext: {
    padding: 2,
    color: '#999'
  },
  heading: {
    color: theme.palette.accentMuted,
    opacity: '0.8'
  },
  content: {
    color: '#999'
  },
  spacer: {
    height: 24
  }
})

export default withRouter(connect(
  mapStateToProps,
  null,
)(withStyles(styles)(Admin)))